import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import EmptyPage from './views/EmptyPage.vue'
import MSStreamAuth from '@/auth/auth';


Vue.use(Router)

var checkAuth = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (!MSStreamAuth.getMyUser().email)
      next({ path: '/mail' })
    else if (!MSStreamAuth.getMyUser().passwordModified)
      next({ path: '/changePassword' })
    else
      next()
  } else {
    next({ path: '/auth' })
  }
}

var checkAuthVerifyMail = function (to, from, next) {
  if (MSStreamAuth.check()) {
      next()
  } else {
    next({ path: '/auth' })
  }
}

var checkAuthMail = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (!MSStreamAuth.getMyUser().email)
      next();
    else if (!MSStreamAuth.getMyUser().passwordModified)
      next({ path: '/changePassword' })
    else
      next({ path: '/' })
  } else {
    next({ path: '/auth' })
  }
}

var checkAuthChangePassword = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (!MSStreamAuth.getMyUser().email)
      next({ path: '/mail' });
    else if (!MSStreamAuth.getMyUser().passwordModified)
      next()
    else
      next({ path: '/' })
  } else {
    next({ path: '/auth' })
  }
}

var reverseCheckAuth = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (!MSStreamAuth.getMyUser().email)
      next({ path: '/mail' })
    else if (!MSStreamAuth.getMyUser().passwordModified)
      next({ path: '/changePassword' })
    else
      next()
  } else {
    next()
  }
}

var checkAuthRoot = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (!MSStreamAuth.getMyUser().email) {
      next({ path: '/mail' })
    }
    else if (!MSStreamAuth.getMyUser().passwordModified)
      next({ path: '/changePassword' })
    else {
      if (MSStreamAuth.getMyUser().client_infos[0].type !== "plugin") {
        next({ path: '/videos' });
      } else {
        next({ path: '/plugindoc' });
      }
    }
  } else {
    next({ path: '/auth' })
  }
}

var checkAuthAndAdmin = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (!MSStreamAuth.getMyUser().email)
      next({ path: '/mail' })
    else if (!MSStreamAuth.getMyUser().passwordModified)
      next({ path: '/changePassword' })
    else {
      if (MSStreamAuth.getMyUser().roles.indexOf('admin') > -1) {
        next()
      } else {
        next({ path: '/' })
      }
    }

  } else {
    next({ path: '/auth' })
  }
}

var checkAuthAndManager = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (!MSStreamAuth.getMyUser().email)
      next({ path: '/mail' })
    else if (!MSStreamAuth.getMyUser().passwordModified)
      next({ path: '/changePassword' })
    else {
      if (MSStreamAuth.getMyUser().roles.indexOf('manager') > -1) {
        next()
      } else {
        next({ path: '/' })
      }
    }

  } else {
    next({ path: '/auth' })
  }
}

var checkAuthAndManagerOrEditor = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (!MSStreamAuth.getMyUser().email)
      next({ path: '/mail' })
    else if (!MSStreamAuth.getMyUser().passwordModified)
      next({ path: '/changePassword' })
    else {
      if (MSStreamAuth.getMyUser().roles.indexOf('manager') > -1 || MSStreamAuth.getMyUser().roles.indexOf('editor') > -1) {
        next()
      } else {
        next({ path: '/' })
      }
    }


  } else {
    next({ path: '/auth' })
  }
}

var checkAuthAndVireed = function (to, from, next) {
  if (MSStreamAuth.check()) {
    if (MSStreamAuth.getMyUser().client_infos[0].vireed === true && (MSStreamAuth.getMyUser().roles.indexOf('manager') > -1 || MSStreamAuth.getMyUser().roles.indexOf('vireed') > -1)) {
      next()
    } else {
      next({ path: '/' })
    }

  } else {
    next({ path: '/auth' })
  }
}


export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter: checkAuthRoot,
      component: EmptyPage
    },
    {
      path: '/videos',
      name: 'videos',
      beforeEnter: checkAuth,
      component: () => import('./views/Home.vue')
    },
    {
      path: '/plugindoc',
      name: 'plugindoc',
      beforeEnter: checkAuth,
      component: () => import('./views/PlugInPage.vue')
    },
    {
      path: '/config',
      name: 'config',
      beforeEnter: checkAuth,
      component: () => import('./views/ECDN.vue')
    },
    {
      path: '/auth',
      name: 'auth',
      beforeEnter: reverseCheckAuth,
      component: () => import('./views/Auth.vue')
    },
    {
      path: '/auth/:username',
      name: 'auth2',
      beforeEnter: reverseCheckAuth,
      component: () => import('./views/Auth.vue')
    },
    {
      path: '/videoupload/:videoType',
      name: 'videoupload',
      beforeEnter: checkAuth,
      component: () => import('./views/VideoUpload.vue')
    },
    {
      path: '/scenelist',
      name: 'scene lists',
      beforeEnter: checkAuth,
      component: () => import('./views/SceneListPage.vue')
    },
    {
      path: '/payments',
      name: 'payments',
      beforeEnter: checkAuthAndManager,
      component: () => import('./views/PaymentPage.vue')
    },
    {
      path: '/doc',
      name: 'doc',
      beforeEnter: checkAuth,
      component: () => import('./views/DocPage.vue')
    },
    {
      path: '/doc/:main',
      name: 'doc2',
      beforeEnter: checkAuth,
      component: () => import('./views/DocPage.vue')
    },
    {
      path: '/doc/:main/:sub',
      name: 'doc3',
      beforeEnter: checkAuth,
      component: () => import('./views/DocPage.vue')
    },
    {
      path: '/capture',
      name: 'capture',
      beforeEnter: checkAuth,
      component: () => import('./views/Capture.vue')
    },
    {
      path: '/captureWindow',
      name: 'captureWindow',
      beforeEnter: checkAuth,
      component: () => import('./views/Capture.vue')
    },
    {
      path: '/captureWindow/:uuid',
      name: 'captureWindowUuid',
      beforeEnter: checkAuth,
      component: () => import('./views/Capture.vue')
    },
    {
      path: '/vireed',
      name: 'vireed',
      beforeEnter: checkAuth,
      component: () => import('./views/VireedPage.vue')
    },
    {
      path: '/newproject',
      name: 'newproject',
      beforeEnter: checkAuth,
      component: () => import('./views/VireedNewProject.vue')
    },
    {
      path: '/vireed/:projectId/:version',
      name: 'vireedplayer',
      beforeEnter: checkAuth,
      component: () => import('./views/VireedPlayerPage.vue')
    },
    {
      path: '/delivery',
      name: 'delivery',
      beforeEnter: checkAuth,
      component: () => import('./views/Capture.vue')
    },
    {
      path: '/delivery/:roomID',
      name: 'delivery2',
      beforeEnter: checkAuth,
      component: () => import('./views/Capture.vue')
    },
    {
      path: '/directstream',
      name: 'direct stream',
      beforeEnter: checkAuth,
      component: () => import('./views/DirectStreamPage.vue')
    },
    {
      path: '/capture/:uuid',
      name: 'captureuuid',
      beforeEnter: checkAuth,
      component: () => import('./views/Capture.vue')
    },
    {
      path: '/export',
      name: 'export',
      beforeEnter: checkAuthAndManagerOrEditor,
      component: () => import('./views/Export.vue')
    },
    {
      path: '/player/:uuid',
      name: 'player',
      beforeEnter: checkAuth,
      component: () => import('./views/Player.vue')
    },
    {
      path: '/newuser',
      name: 'newuser',
      beforeEnter: checkAuthAndManager,
      component: () => import('./views/CreateUser.vue')
    },
    {
      path: '/manageuser',
      name: 'manageuser',
      beforeEnter: checkAuthAndAdmin,
      component: () => import('./views/UserManagementPage.vue')
    },
    {
      path: '/newclient',
      name: 'newclient',
      beforeEnter: checkAuthAndAdmin,
      component: () => import('./views/CreateClient.vue')
    },
    {
      path: '/aide',
      name: 'aide',
      beforeEnter: checkAuth,
      component: () => import('./views/Aide.vue')
    },
    {
      path: '/analytics',
      name: 'analytics',
      beforeEnter: checkAuthAndManagerOrEditor,
      component: () => import('./views/Analytics.vue')
    },
    {
      path: '/analytics/:videoID',
      name: 'analyticsvideo',
      beforeEnter: checkAuthAndManagerOrEditor,
      component: () => import('./views/AnalyticsVideo.vue')
    },
    {
      path: '/profil',
      name: 'profil',
      beforeEnter: checkAuth,
      component: () => import('./views/Profil.vue')
    },
    {
      path: '/redirect',
      name: 'redirect',
      beforeEnter: checkAuth,
      component: () => import('./views/RedirectPage.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      beforeEnter: checkAuthAndAdmin,
      component: () => import('./views/AdminPage.vue')
    },
    {
      path: '/videosadmin/:uuid',
      name: 'videosadmin',
      beforeEnter: checkAuthAndAdmin,
      component: () => import('./views/VideoAdminPage.vue')
    },
    {
      path: '/alert',
      name: 'alert',
      beforeEnter: checkAuth,
      component: () => import('./views/Alert.vue')
    },
    {
      path: '/alert/:uuid',
      name: 'alertuuid',
      beforeEnter: checkAuth,
      component: () => import('./views/Alert.vue')
    },
    {
      path: '/debug',
      name: 'debug',
      component: () => import('./views/Debug.vue')
    },
    {
      path: '/chat',
      beforeEnter: checkAuth,
      name: 'chat',
      component: () => import('./views/ChatPage.vue')
    },
    {
      path: '/chat/:projectId',
      beforeEnter: checkAuth,
      name: 'chat project',
      component: () => import('./views/ChatProject.vue')
    },
    {
      path: '/chat/:roomType/:chatRoomId',
      beforeEnter: checkAuth,
      name: 'chat',
      component: () => import("./views/ChatPageSingle.vue")
    },
    {
      path: '/mail',
      beforeEnter: checkAuthMail,
      name: 'mail',
      component: () => import("./views/mailPage.vue")
    },
    {
      path: '/changePassword',
      beforeEnter: checkAuthChangePassword,
      name: 'changePassword',
      component: () => import("./views/changePasswordPage.vue")
    },
    {
      path: '/verifyMail',
      beforeEnter: checkAuthVerifyMail,
      name: 'verifymail',
      component: () => import("./views/VerifyMailPage.vue")
    },
    {
      path: '/chatLive/:liveId',
      name: 'chatlive',
      component: () => import("./components/VideoChat.vue")
    },
    {
      path : '/videosplugin',
      beforeEnter: checkAuth,
      name : 'videolistPlugin',
      component : () => import("./views/VideosPlugin.vue")
    },
    {
      path : '/cdn',
      beforeEnter: checkAuth,
      name : 'optionnalCDN',
      component : () => import("./views/PluginCDN.vue")
    },
    {
      path : '/pluginpaymentsuccess',
      beforeEnter: checkAuth,
      name : 'pluginpaymentsuccess',
      component : () => import("./views/PluginPaymentSuccess.vue")
    },
    {
      path : '/pluginpaymentfailure',
      beforeEnter: checkAuth,
      name : 'pluginpaymentfailure',
      component : () => import("./views/PluginPaymentFailure.vue")
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior(to, from) {
    return { x: 0, y: 0 }
  }
})
